import { useContext } from 'react'
import sidebarContext, { ISidebarContext } from '../contexts/sidebarContext/sidebarContext'

const useSidebar = () => {
    return useContext(sidebarContext) as ISidebarContext
}

export default useSidebar